import { Injectable } from '@angular/core';
import { AccountingGroupsRepository } from '@core/repositories/accounting-groups.repository';
import { AccountingGroup } from '@shared/interfaces/accounting-group';
import { Observable, of, throwError } from 'rxjs';

interface ResultAccountingGroup {
  id: number;
  attributes: {
    name: string;
  };
  relationships: {
    rule: {
      id: number;
      attributes: {
        name: string;
      };
    };
  };
}

@Injectable({ providedIn: 'root' })
export class FakeAccountingGroupsRepository
  implements AccountingGroupsRepository {
  url: string;

  dataAccountingGroups: Array<ResultAccountingGroup> = [
    {
      id: 301,
      attributes: {
        name: 'Grupo 3'
      },
      relationships: {
        rule: {
          id: 501,
          attributes: {
            name: 'Regla 5'
          }
        }
      }
    },
    {
      id: 401,
      attributes: {
        name: 'Grupo 4'
      },
      relationships: {
        rule: {
          id: 401,
          attributes: {
            name: 'Regla 4'
          }
        }
      }
    },
    {
      id: 501,
      attributes: {
        name: 'Grupo 5'
      },
      relationships: {
        rule: {
          id: 301,
          attributes: {
            name: 'Regla 3'
          }
        }
      }
    }
  ];

  accountingGroups = {
    data: this.dataAccountingGroups
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.accountingGroups);
  }

  add(accountingGroup: AccountingGroup): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(accountingGroup: AccountingGroup): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  delete(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
